import { useGetRecentItemsWithActiveStreams } from '#pplx/frontend/apps/ask/hooks/recent-items-query-hooks/useGetRecentItemsWithActiveStreams.js';
import { useSidebarV2 } from '#pplx/frontend/apps/ask/hooks/sidebar-graphql-v2/context.js';
import { usePinnedItemsQuery } from '#pplx/frontend/apps/ask/hooks/threads-hooks/usePinnedItemsQuery.js';
import { useSidebarProjects } from '#pplx/frontend/apps/ask/layout/sidebar/core/lite/useSidebarProjects.js';
import { useSession } from '#pplx/frontend/auth/useSession.js';
import { useEffect, useState } from 'react';
const INITIAL_LOAD_TIMEOUT_MS = 5_000;
export function useSidebarInitialLoad({ isIncognito, teammatesPending = false, }) {
    const sidebarV2 = useSidebarV2();
    const { session, status: sessionStatus } = useSession();
    const signedIn = sessionStatus === 'authenticated';
    const viewerKey = session?.user.id ?? sessionStatus;
    const pinned = usePinnedItemsQuery({
        enabled: signedIn && !isIncognito && sidebarV2 == null,
        reason: 'sidebar-initial-pinned-items',
    });
    const projects = useSidebarProjects({ enabled: signedIn, showPinnedOnly: false });
    const recents = useGetRecentItemsWithActiveStreams({
        reason: 'sidebar-initial-recents',
        graphQLSource: sidebarV2?.recents,
        filter: sidebarV2?.recentsFilter,
        excludeAsi: false,
    });
    // Placeholder pins are an empty array, but do not establish which Recents rows are pinned.
    const pinnedPending = !isIncognito &&
        (sidebarV2
            ? sidebarV2.pins.status === 'loading'
            : (pinned.isPending || pinned.isPlaceholderData) && pinned.fetchStatus !== 'paused');
    const projectsPending = projects.status === 'pending' && projects.fetchStatus !== 'paused';
    const pending = sessionStatus === 'loading' ||
        (signedIn && (projectsPending || pinnedPending || recents.isLoading || teammatesPending));
    const [revealedViewer, setRevealedViewer] = useState(null);
    // The reveal barrier applies once per viewer; refreshes must keep the existing lists visible.
    useEffect(() => {
        if (!pending)
            setRevealedViewer(viewerKey);
    }, [pending, viewerKey]);
    useEffect(() => {
        if (sessionStatus === 'loading' || revealedViewer === viewerKey)
            return;
        const timeout = setTimeout(() => setRevealedViewer(viewerKey), INITIAL_LOAD_TIMEOUT_MS);
        return () => clearTimeout(timeout);
    }, [revealedViewer, sessionStatus, viewerKey]);
    return sessionStatus === 'loading' || (revealedViewer !== viewerKey && pending);
}
//# sourceMappingURL=useSidebarInitialLoad.js.map